import React from "react";

const LayOutContainer = ({ children }) => {
  window.scrollTo(0, 0);
  return (
    <div className="mx-auto md:px-0 overflow-x-hidden xl:max-w-[1600px]">
      {children}
    </div>
  );
};

export default LayOutContainer;
